import {
    UPDATE_USER_PRODUCT_MEMBERSHIP_POOL,
    UPDATE_USER_PRODUCT_MEMBERSHIP_POOL_FAILURE,
    UPDATE_USER_PRODUCT_MEMBERSHIP_POOL_SUCCESS,
} from 'store/actions/types';

export const updateUserProductMembershipPool = (payload) => {
    return {
        type: UPDATE_USER_PRODUCT_MEMBERSHIP_POOL,
        payload,
    };
};

export const updateUserProductMembershipPoolFailure = (payload) => {
    return {
        type: UPDATE_USER_PRODUCT_MEMBERSHIP_POOL_FAILURE,
        payload,
    };
};

export const updateUserProductMembershipPoolSuccess = (payload) => {
    return {
        type: UPDATE_USER_PRODUCT_MEMBERSHIP_POOL_SUCCESS,
        payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/users/product-membership-pool/updateUserProductMembershipPool.js